export const downloadApp = 'https://sen123.top/dafa.apk'

